import {types, flow} from 'mobx-state-tree';
import * as api from '../../services/api';
import {ListingModel} from '../ListingsListModel';
import {TeamModel} from '../TeamsListModel';

// tslint:disable
export type ListingDetailActions = {
  getListing: (listingId: number) => void;
  getTeam: (teamId: number) => void;
};

const ListingDetailModel = types
  .model('ListingDetailModel', {
    isLoading: types.optional(types.boolean, false),
    isLoadingTeam: types.optional(types.boolean, false),
    isLoadingAddNewMember: types.optional(types.boolean, false),
    newUserIdAssign: types.maybe(types.number),
    team: types.maybe(TeamModel),
    listing: types.maybe(ListingModel)
  })
  .actions(self => {
    const withActions = (self as any) as ListingDetailActions;

    return {
      getListing: flow(function*(listingId: number) {
        self.isLoading = true;
        const response = yield api.getListing(listingId);
        if (response.status === 200 && response.data) {
          // Convert array to map
          let listing = response.data.listing;
          listing.members = listing.members.reduce(
            (results: {[id: string]: any}, r: any) => (
              (results[String(r.id)] = r), results
            ),
            {}
          );
          self.listing = listing;
          withActions.getTeam(listing.teamId);
        }
        self.isLoading = false;
      }),
      getTeam: flow(function*(teamId: number) {
        self.isLoadingTeam = true;
        const response = yield api.getTeam(teamId);
        if (response.status === 200 && response.data) {
          self.team = response.data.team;
        }
        self.isLoadingTeam = false;
      }),
      removeMember: flow(function*(userId: number) {
        if (self.listing) {
          const response = yield api.removeMemberListing(
            self.listing.id,
            userId
          );
          if (response.status === 200) {
            self.listing.removeMember(userId);
          }
        }
      }),
      assignMember: flow(function*() {
        if (self.listing && self.newUserIdAssign) {
          self.isLoadingAddNewMember = true;
          const newUserRes = yield api.getUser(self.newUserIdAssign);
          const response = yield api.assignMemberToListing(
            self.listing.id,
            self.newUserIdAssign
          );
          if (response.status === 200) {
            self.listing.assignMember(newUserRes.data.user);
          }
          self.isLoadingAddNewMember = false;
        }
      }),
      onChangeNewUserIdAssign: (userId: number) => {
        self.newUserIdAssign = userId;
      }
    };
  });

export type ListingDetailModelType = typeof ListingDetailModel.Type;

export default ListingDetailModel;



// WEBPACK FOOTER //
// ./src/models/ListingDetailModel/ListingDetailModel.ts